import { Widget } from "blue-widgets";

class Burgermenu extends Widget {
  constructor(el) {
    super(el);
    this.scrollPos = 0;
    this.init();
    this.menu;
  }

  init() {
    this.mobileMenuContent = document.querySelector("[data-mobilemenu]");
    this.computedStyle = window.getComputedStyle(this.mobileMenuContent);
    this.mobileMenuContent.style.display = "none";
    this.el.addEventListener("click", this.toggle.bind(this), false);
  }

  toggle() {
    if (this.el.getAttribute("aria-expanded") === "false") {
      this.openMenu();
    } else {
      this.closeMenu();
    }
  }

  scrollLockHandler(lock) {
    const doc = document.body;
    const main = document.querySelector("main");

    if (lock) {
      this.scrollPos = window.scrollY;
      doc.style.position = "fixed";
      doc.style.overflow = "hidden";
      doc.style.height = "100vh";
      main.style.marginTop = `-${this.scrollPos}px`;
    } else {
      doc.style.position = "";
      doc.style.overflow = "";
      doc.style.height = "";
      main.style.marginTop = "";
      window.scrollTo(0, this.scrollPos);
    }
  }

  focusTrap(lock) {
    if (lock) {
      this.mobileMenuContent.focus({ focusVisible: true });
      const tabbableElements = this.mobileMenuContent.querySelectorAll(
        "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
      );
      const lastItem = tabbableElements[tabbableElements.length - 1];
      lastItem.addEventListener("blur", () => {
        this.el.focus({ focusVisible: true });
      });
    }
  }

  openMenu() {
    this.mobileMenuContent.style.display = "flex";
    setTimeout(() => {
      this.el.setAttribute("aria-expanded", "true");
      this.mobileMenuContent.classList.add("isOpen");
      window.addEventListener("click", this.backdropclick.bind(this), false);
      window.addEventListener("resize", this.closeMenu.bind(this), false);
      this.scrollLockHandler(true);
      this.focusTrap(true);
    }, parseFloat(this.computedStyle.getPropertyValue("transition-duration")) * 1000);
  }

  closeMenu() {
    this.el.setAttribute("aria-expanded", "false");
    this.mobileMenuContent.classList.remove("isOpen");
    window.removeEventListener("click", this.backdropclick.bind(this), false);
    window.removeEventListener("resize", this.closeMenu.bind(this), false);
    this.scrollLockHandler(false);
    this.focusTrap(false);
    setTimeout(() => {
      this.mobileMenuContent.style.display = "none";
    }, parseFloat(this.computedStyle.getPropertyValue("transition-duration")) * 1000);
  }

  backdropclick(e) {
    if (e.target.classList.contains("mobile-menu__backdrop")) {
      this.closeMenu();
    }
  }

  beforeRemove() {
    this.el.removeEventListener("click", this.toggle, false);
    window.removeEventListener("resize", this.closeMenu, false);
  }
}

export default Burgermenu;
